import { type BaseApiContract } from "shared/api/apiRequestContractHandler";
import { HttpMethod } from "shared/api/http";
import { type PaginatedResults } from "shared/api/types/pagination";
import { type SocietyProfileParamsInput } from "shared/api/types/society/[societyId]/profiles/[profileId]/index";
import { type MarkNotificationsAsReadBodyInput } from "shared/api/types/society/[societyId]/profiles/[profileId]/notifications";
import { type NotificationEventView } from "shared/mappers/database/notification-event/notification-event";
export const getSocietyProfileNotificationsContract: BaseApiContract<
  SocietyProfileParamsInput,
  undefined,
  PaginatedResults<NotificationEventView>
> = {
  method: HttpMethod.GET,
  apiRoute: "/api/v1/society/[societyId]/profiles/[profileId]/notifications",
  paramsType: {} as SocietyProfileParamsInput,
  responseType: {} as PaginatedResults<NotificationEventView>,
};
export const patchSocietyProfileNotificationsContract: BaseApiContract<
  SocietyProfileParamsInput,
  MarkNotificationsAsReadBodyInput,
  void
> = {
  method: HttpMethod.PATCH,
  apiRoute: "/api/v1/society/[societyId]/profiles/[profileId]/notifications",
  paramsType: {} as SocietyProfileParamsInput,
  bodyType: {} as MarkNotificationsAsReadBodyInput,
  responseType: undefined as unknown as void,
};
